import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import DynamicGroupWizard from "../DynamicGroupWizard/DynamicGroupWizard";
import {
  DynamicGroupWizardData,
  INITIAL_DYNAMIC_GROUP_DATA,
} from "../DynamicGroupWizard/types";
import { enrollGroupToLearningObjects } from "../enrollGroupToLearningObjects";

const AddDynamicGroup: React.FC = () => {
  const { id: corporateId = "" } = useParams();
  const navigate = useNavigate();
  const backTo = `/v2/corporate/${corporateId}/detail/users-groups?tab=dynamic-groups`;
  const [submitting, setSubmitting] = useState(false);

  const { trigger } = useSWRMutation(
    ServicesURL.dynamicGroups.replace(":idCorporate", corporateId),
    (url: string, { arg }: { arg: any }) => fetcher(url, MethodType.POST, arg),
  );

  const onComplete = async (data: DynamicGroupWizardData) => {
    setSubmitting(true);
    try {
      const res: any = await trigger({
        name: data.name || "",
        description: data.description || "",
        sets: data.sets,
      });
      await enrollGroupToLearningObjects({
        corporateId,
        groupId: res?.id,
        groupType: "DYNAMIC",
        loSelections: data.loSelections,
        enrollType: data.enrollType,
      });
      navigate(backTo);
    } catch (error) {
      setSubmitting(false);
      throw error;
    }
  };

  return (
    <DynamicGroupWizard
      initialData={INITIAL_DYNAMIC_GROUP_DATA}
      backTo={backTo}
      onComplete={onComplete}
      isCompleting={submitting}
    />
  );
};

export default AddDynamicGroup;
